import React from 'react';
import type { LayerRenderer } from '../../../types';
import LineSymbolEditor from './LineSymbolEditor';

/**
 * LINE symbology only — colour-based styling.
 *
 * Deliberately contains NO symbol gallery, no point size, no rotation and no
 * point outline controls. A line is represented by its colour, width, opacity
 * and dash pattern; it has no concept of an icon.
 */
export default function LineSymbologyPanel({
  renderer,
  onChange,
}: {
  renderer: LayerRenderer;
  onChange: (changes: Partial<LayerRenderer>) => void;
}) {
  return <LineSymbolEditor renderer={renderer} onChange={onChange} />;
}
